import { render, staticRenderFns } from "./ComparatorGraphic.vue?vue&type=template&id=bd18be28&scoped=true&"
import script from "./ComparatorGraphic.vue?vue&type=script&lang=js&"
export * from "./ComparatorGraphic.vue?vue&type=script&lang=js&"
import style0 from "./ComparatorGraphic.vue?vue&type=style&index=0&id=bd18be28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd18be28",
  null
  
)

export default component.exports